var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "network-rule-specific-info-card" },
    [
      _c("tabs", {
        attrs: {
          tabs: _vm.tabs,
          "active-tab": _vm.activeTab,
          "tabs-styling": _vm.tabsStyling,
          "tabs-labels-styling": _vm.tabsLabelsStyling,
          "center-tabs": false
        },
        on: {
          startTabChange: function($event) {
            _vm.activeTab = $event
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          style: {
            height: "calc(100% - 60px)",
            "margin-top": "21px",
            "overflow-y": "auto",
            "overflow-x": "hidden"
          }
        },
        [
          _c("fields-list", {
            attrs: {
              fields: _vm.selectedTabFields,
              "editing-data": _vm.editingData
            },
            on: {
              "update-field": function($event) {
                return _vm.$emit("update-specific-field", $event)
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.editingData
        ? _c(
            "div",
            { staticClass: "action-buttons" },
            [
              _c("custom-button", {
                attrs: {
                  label: _vm.$t("Cancel"),
                  "button-color": "#FFF",
                  "label-color": "var(--app-primary-base)",
                  "button-styling": _vm.actionButtonsStyling
                },
                on: {
                  buttonClick: function($event) {
                    return _vm.$emit("cancel-edit")
                  }
                }
              }),
              _vm._v(" "),
              _c("custom-button", {
                attrs: {
                  label: _vm.$t(_vm.submitButtonLabel),
                  "button-color": "var(--app-primary-base)",
                  "label-color": "#FFF",
                  "button-styling": _vm.actionButtonsStylingSave,
                  disabled:
                    typeof _vm.requiredFieldsFilled === "boolean"
                      ? !_vm.requiredFieldsFilled
                      : true
                },
                on: {
                  buttonClick: function($event) {
                    return _vm.$emit("save-material")
                  }
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c80d2a48", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c80d2a48","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/newComponents/SystemSettingsManagement/NetworkRules/NetworkRuleSpecificInfo.vue
// module id = null
// module chunks = 